"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = require("base");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var ConditionalBlock =
/*#__PURE__*/
function (_BlockContainer) {
  babelHelpers.inherits(ConditionalBlock, _BlockContainer);

  function ConditionalBlock() {
    babelHelpers.classCallCheck(this, ConditionalBlock);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ConditionalBlock).apply(this, arguments));
  }

  return ConditionalBlock;
}(_base.BlockContainer);

exports.default = ConditionalBlock;